import * as React from "react";

/**
 * SmokeEffect - Sitenin alt kısmında sağ ve solda duman efekti
 * CSS animasyonları ile hafif ve performanslı
 */
export const SmokeEffect = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 h-[450px] pointer-events-none z-[5] overflow-hidden">
      {/* Sol taraf duman */}
      <div className="absolute bottom-0 left-0 w-[600px] h-full">
        {/* Duman katmanları - sol */}
        <div 
          className="absolute bottom-0 left-0 w-full h-full"
          style={{
            background: 'radial-gradient(ellipse at 0% 100%, rgba(20, 20, 35, 0.95) 0%, rgba(30, 30, 50, 0.7) 25%, rgba(40, 40, 60, 0.4) 45%, transparent 70%)',
            animation: 'smokeLeft 8s ease-in-out infinite',
          }}
        />
        <div 
          className="absolute bottom-0 left-0 w-full h-full"
          style={{
            background: 'radial-gradient(ellipse at 10% 90%, rgba(40, 40, 70, 0.8) 0%, rgba(50, 50, 80, 0.5) 30%, transparent 60%)',
            animation: 'smokeLeft 12s ease-in-out infinite reverse',
          }}
        />
        <div 
          className="absolute bottom-0 left-0 w-[90%] h-[85%]"
          style={{
            background: 'radial-gradient(ellipse at 5% 100%, rgba(25, 25, 45, 0.9) 0%, rgba(35, 35, 55, 0.5) 35%, transparent 65%)',
            animation: 'smokeDrift 10s ease-in-out infinite',
          }}
        />
        {/* Ekstra yoğunluk katmanı */}
        <div 
          className="absolute bottom-0 left-0 w-[70%] h-[60%]"
          style={{
            background: 'radial-gradient(ellipse at 0% 100%, rgba(15, 15, 30, 0.95) 0%, rgba(25, 25, 45, 0.6) 40%, transparent 70%)',
            animation: 'smokeIntense 6s ease-in-out infinite',
          }}
        />
      </div>
      
      {/* Sağ taraf duman */}
      <div className="absolute bottom-0 right-0 w-[600px] h-full">
        {/* Duman katmanları - sağ */}
        <div 
          className="absolute bottom-0 right-0 w-full h-full"
          style={{
            background: 'radial-gradient(ellipse at 100% 100%, rgba(20, 20, 35, 0.95) 0%, rgba(30, 30, 50, 0.7) 25%, rgba(40, 40, 60, 0.4) 45%, transparent 70%)',
            animation: 'smokeRight 8s ease-in-out infinite',
          }}
        />
        <div 
          className="absolute bottom-0 right-0 w-full h-full"
          style={{
            background: 'radial-gradient(ellipse at 90% 90%, rgba(40, 40, 70, 0.8) 0%, rgba(50, 50, 80, 0.5) 30%, transparent 60%)',
            animation: 'smokeRight 12s ease-in-out infinite reverse',
          }}
        />
        <div 
          className="absolute bottom-0 right-0 w-[90%] h-[85%]"
          style={{
            background: 'radial-gradient(ellipse at 95% 100%, rgba(25, 25, 45, 0.9) 0%, rgba(35, 35, 55, 0.5) 35%, transparent 65%)',
            animation: 'smokeDrift 10s ease-in-out infinite reverse',
          }}
        />
        {/* Ekstra yoğunluk katmanı */}
        <div 
          className="absolute bottom-0 right-0 w-[70%] h-[60%]"
          style={{
            background: 'radial-gradient(ellipse at 100% 100%, rgba(15, 15, 30, 0.95) 0%, rgba(25, 25, 45, 0.6) 40%, transparent 70%)',
            animation: 'smokeIntense 6s ease-in-out infinite reverse',
          }}
        />
      </div>
      
      {/* Alt gradient overlay - daha koyu */}
      <div 
        className="absolute bottom-0 left-0 right-0 h-40"
        style={{
          background: 'linear-gradient(to top, rgba(10, 10, 20, 0.9), rgba(15, 15, 25, 0.5), transparent)',
        }}
      />
      
      {/* Animasyon stilleri */}
      <style>{`
        @keyframes smokeLeft {
          0%, 100% {
            transform: translateX(0) translateY(0) scale(1);
          }
          25% {
            transform: translateX(30px) translateY(-15px) scale(1.08);
          }
          50% {
            transform: translateX(15px) translateY(-25px) scale(1.15);
          }
          75% {
            transform: translateX(40px) translateY(-8px) scale(1.05);
          }
        }
        
        @keyframes smokeRight {
          0%, 100% {
            transform: translateX(0) translateY(0) scale(1);
          }
          25% {
            transform: translateX(-30px) translateY(-15px) scale(1.08);
          }
          50% {
            transform: translateX(-15px) translateY(-25px) scale(1.15);
          }
          75% {
            transform: translateX(-40px) translateY(-8px) scale(1.05);
          }
        }
        
        @keyframes smokeDrift {
          0%, 100% {
            transform: translateY(0) scale(1);
          }
          50% {
            transform: translateY(-40px) scale(1.2);
          }
        }
        
        @keyframes smokeIntense {
          0%, 100% {
            opacity: 1;
            transform: scale(1);
          }
          50% {
            opacity: 0.8;
            transform: scale(1.1) translateY(-20px);
          }
        }
      `}</style>
    </div>
  );
};
